import { extractErrorMessage } from '@zealy/utils';
import { apiV2 } from '../services';
export const getTiktokCampaign = async (subdomain) => {
    const res = await apiV2.tiktokCampaign.get({ params: { subdomain } });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getTiktokCampaign fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const isUserRegisteredToTiktokCampaign = async (subdomain, tiktokCampaignId) => {
    const res = await apiV2.tiktokCampaign.isUserRegistered({
        params: { subdomain },
        query: { tiktokCampaignId },
    });
    if (res.status === 200) {
        return res.body.isRegistered;
    }
    throw new Error(`isUserRegistered fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const registerToTiktokCampaign = async (subdomain, tiktokCampaignId) => {
    const res = await apiV2.tiktokCampaign.register({
        params: { subdomain, tiktokCampaignId },
        body: {},
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`registerToTiktokCampaign fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getTiktokCampaignLeaderboard = async (subdomain, tiktokCampaignId, page = 1, pageSize = 20) => {
    const res = await apiV2.tiktokCampaign.getLeaderboard({
        params: { subdomain },
        query: { tiktokCampaignId, page, pageSize },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getTiktokCampaignLeaderboard fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getUserRank = async (subdomain, tiktokCampaignId) => {
    const res = await apiV2.tiktokCampaign.getUserRank({
        params: { subdomain },
        query: { tiktokCampaignId },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getUserRank fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
